import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "releases-block__text" }
const _hoisted_2 = { class: "releases-block__category card-large__category" }
const _hoisted_3 = { class: "releases-block__title card-large__title" }
const _hoisted_4 = { class: "releases-block__author card-large__author" }

import { onBeforeMount, ref } from 'vue'

import { Book } from '@/models/interfaces'
import { BooksView } from '@/models/doc.book'
import { platform } from '@/services/platform'
import { isSafari as _isSafari } from '@/helpers/userAgent'

import BookCover from '@/app/components/book/card/BookCover.vue'
import BookCardBackground from '@/app/components/book/card/BookCardBackground.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'NewReleasesCard',
  props: {
    doc: null,
    view: null
  },
  setup(__props: any) {



const isSafari = ref(false)

onBeforeMount(async () => {
  isSafari.value = (await platform.isIOS()) || _isSafari()
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: __props.view.startLinkParams(__props.doc),
    class: _normalizeClass(["releases-block__item", { 'releases-block__item--safari': isSafari.value }])
  }, {
    default: _withCtx(() => [
      _createVNode(BookCover, {
        doc: __props.doc,
        coverClass: "releases-block__img"
      }, null, 8, ["doc"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h5", _hoisted_2, _toDisplayString(__props.view.firstTagShort(__props.doc)), 1),
        _createElementVNode("h3", _hoisted_3, _toDisplayString(__props.doc.title), 1),
        _createElementVNode("h4", _hoisted_4, " By " + _toDisplayString(__props.doc.author), 1)
      ]),
      (!isSafari.value)
        ? (_openBlock(), _createBlock(BookCardBackground, {
            key: 0,
            doc: __props.doc
          }, null, 8, ["doc"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["to", "class"]))
}
}

})